export const agentConsoleCreditRatios = "/generative_ai/agents/agent_console_credit_ratios";
